export const KEY_EDIT = 'edit';
export const KEY_WEB_IDE = 'webide';
export const KEY_GITPOD = 'gitpod';
export const KEY_PIPELINE_EDITOR = 'pipeline_editor';
